import { render, staticRenderFns } from "./MzShopifySearchBox.vue?vue&type=template&id=422b6be6&"
import script from "./MzShopifySearchBox.vue?vue&type=script&lang=js&"
export * from "./MzShopifySearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports